// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"312":"f0bea3b6","401":"86ef35b7","529":"457c3d95","540":"63234c2a","704":"6fb49d26","759":"85637a69","912":"457c3d95"}[chunkId] + ".chunk.css";
};